import React from "react";
import PropTypes from "prop-types";
import { syncNewEmployee } from "redux/organization/employeeSlice";
import SyncEmployeeConfirm from "./SyncEmployeeConfirm";

const SyncNewEmployeeConfirm = ({ showModal, setshowModal }) => (
  <SyncEmployeeConfirm
    showModal={showModal}
    setshowModal={setshowModal}
    title="Sync new employees"
    message="Are you sure to sync new employees from iHRM now?"
    action={syncNewEmployee}
  />
);

SyncNewEmployeeConfirm.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
};

export default SyncNewEmployeeConfirm;
